import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _class_call_check } from "@swc/helpers/_/_class_call_check";
import { _ as _create_class } from "@swc/helpers/_/_create_class";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _type_of } from "@swc/helpers/_/_type_of";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
var __decorate = this && this.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if ((typeof Reflect === "undefined" ? "undefined" : _type_of(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { logError } from "@faire/web--source/common/logging";
import { makeObservable } from "@faire/web--source/common/makeObservable";
import getProducts from "@faire/web-api--source/api/product/get-messenger-previews/post";
import sendMessengerMessageV3 from "@faire/web-api--source/api/v3/messenger/send-message/post";
import { IMessageContents } from "@faire/web-api--source/faire/messenger/IMessageContents";
import { ISendMessengerMessageRequestV3 } from "@faire/web-api--source/faire/messenger/ISendMessengerMessageRequestV3";
import { IUser } from "@faire/web-api--source/indigofair/data/IUser";
import { UserRole } from "@faire/web-api--source/indigofair/data/UserRole";
import clone from "lodash/clone";
import compact from "lodash/compact";
import { action, computed, observable } from "mobx";
import { fromPromise } from "mobx-utils";
import { uploadImageFile } from "./uploadImageFile";
export var MessageModel = /*#__PURE__*/ function() {
    "use strict";
    function MessageModel(conversation, data) {
        var _this = this;
        var images = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : undefined, products = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : [];
        var _this1 = this;
        _class_call_check(this, MessageModel);
        var _this2 = this;
        this.conversation = conversation;
        this.productTokens = [];
        this.fetchProducts = function() {
            if (!_this.productTokens.length) {
                return;
            }
            _this.productPromises = fromPromise(getProducts({
                product_tokens: _this.productTokens
            }));
        };
        this.updateMessage = function(messageData, images) {
            var products = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
            _this1.data = messageData;
            _this1._images = images;
            _this1._error = undefined;
            _this1.productTokens = clone(products);
        };
        this._isDeleting = false;
        this.setIsDeleting = function(isDeleting) {
            _this._isDeleting = isDeleting;
        };
        this.deleteMessage = function() {
            return _this.conversation.deleteMessage(_this.token);
        };
        /*
         * async
         */ this.sendMessage = /*#__PURE__*/ _async_to_generator(function() {
            var updatedConversation, _updatedConversation_latest_message, imageTokens, _this_productTokens, messageContents, result, e;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (_this2.data.updated_at !== undefined) {
                            throw new Error("This should not be called if the message is already on the server - Ian");
                        }
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            7,
                            ,
                            8
                        ]);
                        return [
                            4,
                            _this2.uploadImages()
                        ];
                    case 2:
                        imageTokens = _state.sent();
                        messageContents = IMessageContents.build({
                            text: _this2.data.text,
                            image_tokens: imageTokens !== null && imageTokens !== void 0 ? imageTokens : [],
                            product_tokens: (_this_productTokens = _this2.productTokens) !== null && _this_productTokens !== void 0 ? _this_productTokens : []
                        });
                        if (!!_this2.conversation.token) return [
                            3,
                            4
                        ];
                        return [
                            4,
                            _this2.conversation.createConversation(messageContents)
                        ];
                    case 3:
                        updatedConversation = _state.sent();
                        return [
                            3,
                            6
                        ];
                    case 4:
                        return [
                            4,
                            sendMessengerMessageV3(ISendMessengerMessageRequestV3.build({
                                conversation_token: _this2.conversation.token,
                                message_contents: messageContents
                            }))
                        ];
                    case 5:
                        result = _state.sent();
                        updatedConversation = result.conversation;
                        _state.label = 6;
                    case 6:
                        if (!updatedConversation) {
                            throw new Error("This request should have returned a conversation.");
                        }
                        _this2.data.token = (_updatedConversation_latest_message = updatedConversation.latest_message) === null || _updatedConversation_latest_message === void 0 ? void 0 : _updatedConversation_latest_message.token;
                        _this2.conversation.updateConversation(updatedConversation);
                        return [
                            3,
                            8
                        ];
                    case 7:
                        e = _state.sent();
                        logError(e);
                        _this2._error = e;
                        return [
                            3,
                            8
                        ];
                    case 8:
                        return [
                            2
                        ];
                }
            });
        });
        this.setError = function(message) {
            _this._error = message;
        };
        this.uploadImages = /*#__PURE__*/ _async_to_generator(function() {
            var images, _tmp;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _tmp = _this2._images;
                        if (!_tmp) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            Promise.all(_this2._images.map(uploadImageFile))
                        ];
                    case 1:
                        _tmp = _state.sent();
                        _state.label = 2;
                    case 2:
                        images = _tmp;
                        return [
                            2,
                            images && compact(images.map(function(image) {
                                return image.token;
                            }))
                        ];
                }
            });
        });
        makeObservable(this);
        this.updateMessage(data, images, products);
    }
    _create_class(MessageModel, [
        {
            key: "products",
            get: function get() {
                var _this_productPromises;
                if (this.isPending) {
                    return [];
                }
                var _this_productPromises_case;
                return (_this_productPromises_case = (_this_productPromises = this.productPromises) === null || _this_productPromises === void 0 ? void 0 : _this_productPromises.case({
                    fulfilled: function(response) {
                        return response.product_previews;
                    }
                })) !== null && _this_productPromises_case !== void 0 ? _this_productPromises_case : [];
            }
        },
        {
            key: "token",
            get: /*
     * Getters
     */ function get() {
                return this.data.token;
            }
        },
        {
            key: "conversationMessageAuthors",
            get: function get() {
                return this.conversation.messageAuthors;
            }
        },
        {
            key: "error",
            get: function get() {
                return this._error;
            }
        },
        {
            key: "conversationToken",
            get: function get() {
                return this.conversation.token;
            }
        },
        {
            key: "authorToken",
            get: function get() {
                return this.data.author_token;
            }
        },
        {
            key: "isFromOtherUser",
            get: function get() {
                return this.data.author_token === this.conversation.otherPartyToken;
            }
        },
        {
            key: "isFromCurrentUser",
            get: function get() {
                return this.data.author_token === this.conversation.userToken;
            }
        },
        {
            key: "isFromSameRetailerAsCurrentUser",
            get: function get() {
                var _this = this;
                var _this_conversationMessageAuthors_find_roles, _this_conversationMessageAuthors_find;
                // Whether the message is from a retailer team that we are a part of.
                return this.conversation.isCurrentUserARetailer && !!((_this_conversationMessageAuthors_find = this.conversationMessageAuthors.find(function(author) {
                    return _this.authorToken === author.token;
                })) === null || _this_conversationMessageAuthors_find === void 0 ? void 0 : (_this_conversationMessageAuthors_find_roles = _this_conversationMessageAuthors_find.roles) === null || _this_conversationMessageAuthors_find_roles === void 0 ? void 0 : _this_conversationMessageAuthors_find_roles.includes(UserRole.RETAILER));
            }
        },
        {
            key: "isFromSameBrandAsCurrentUser",
            get: function get() {
                var _this = this;
                // Whether the message is from a brand team that we are a part of.
                var messageAuthor = this.conversationMessageAuthors.find(function(author) {
                    return _this.authorToken === author.token;
                });
                return this.conversation.isCurrentUserABrand && (messageAuthor === null || messageAuthor === void 0 ? void 0 : messageAuthor.type) === IUser.Type.BRAND_USER;
            }
        },
        {
            key: "createdAt",
            get: function get() {
                return this.data.created_at;
            }
        },
        {
            key: "deletableUntil",
            get: function get() {
                return this.data.deletable_until;
            }
        },
        {
            key: "isRead",
            get: function get() {
                if (this.data.read_at) {
                    return true;
                }
                if (this.isFromOtherUser && this.data.created_at && this.conversation.lastReadByCurrentUser) {
                    return this.data.created_at < this.conversation.lastReadByCurrentUser;
                }
                return false;
            }
        },
        {
            key: "shouldPopUp",
            get: function get() {
                if (this.isFromOtherUser && this.data.should_pop_up && this.createdAt) {
                    var sevenDaysAgo = Date.now() - 7 * 24 * 60 * 60 * 1000;
                    if (sevenDaysAgo < this.createdAt) {
                        return true;
                    }
                }
                return false;
            }
        },
        {
            key: "isLatestReadFromCurrentUser",
            get: function get() {
                return this === this.conversation.latestMessage && this.isRead;
            }
        },
        {
            key: "isLatestDelivered",
            get: function get() {
                return this === this.conversation.latestMessage;
            }
        },
        {
            key: "text",
            get: function get() {
                if (this.isPending) {
                    return undefined;
                }
                return this.data.text;
            }
        },
        {
            key: "images",
            get: function get() {
                if (this.isPending) {
                    return [];
                }
                if (this._images) {
                    return this._images.map(function(image) {
                        return {
                            file: Object.assign(image, {
                                preview: URL.createObjectURL(image)
                            })
                        };
                    });
                }
                if (this.data.images) {
                    return this.data.images.map(function(image) {
                        return {
                            image: image
                        };
                    });
                }
                return [];
            }
        },
        {
            key: "isDeleted",
            get: function get() {
                return !!this.data.deleted;
            }
        },
        {
            key: "isPending",
            get: function get() {
                return this._isDeleting;
            }
        },
        {
            key: "latestMessageAuthorFirstName",
            get: function get() {
                var _this_data_author_first_name;
                return (_this_data_author_first_name = this.data.author_first_name) !== null && _this_data_author_first_name !== void 0 ? _this_data_author_first_name : "";
            }
        },
        {
            key: "otherPartyFirstName",
            get: function get() {
                var _this_conversation_otherParty, _this_conversation_otherParty1;
                if (!this.isFromOtherUser) {
                    return undefined;
                }
                return ((_this_conversation_otherParty = this.conversation.otherParty) === null || _this_conversation_otherParty === void 0 ? void 0 : _this_conversation_otherParty.first_name) || ((_this_conversation_otherParty1 = this.conversation.otherParty) === null || _this_conversation_otherParty1 === void 0 ? void 0 : _this_conversation_otherParty1.name);
            }
        },
        {
            key: "otherPartyProfilePicUrl",
            get: function get() {
                if (!this.isFromOtherUser) {
                    return undefined;
                }
                return this.conversation.otherPartyProfilePicUrl;
            }
        },
        {
            key: "currentPartyProfilePicUrl",
            get: function get() {
                return this.conversation.userProfilePhotoUrl;
            }
        }
    ]);
    return MessageModel;
}();
MessageModel.createNewMessage = function(conversation, message, images) {
    var products = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : [];
    return new MessageModel(conversation, _object_spread_props(_object_spread({}, message), {
        author_token: conversation.userToken,
        created_at: Date.now()
    }), images, products);
};
__decorate([
    observable
], MessageModel.prototype, "data", void 0);
__decorate([
    observable
], MessageModel.prototype, "_error", void 0);
__decorate([
    observable
], MessageModel.prototype, "_images", void 0);
__decorate([
    observable
], MessageModel.prototype, "productTokens", void 0);
__decorate([
    observable
], MessageModel.prototype, "productPromises", void 0);
__decorate([
    action
], MessageModel.prototype, "fetchProducts", void 0);
__decorate([
    computed
], MessageModel.prototype, "products", null);
__decorate([
    action
], MessageModel.prototype, "updateMessage", void 0);
__decorate([
    computed
], MessageModel.prototype, "isFromOtherUser", null);
__decorate([
    computed
], MessageModel.prototype, "isFromCurrentUser", null);
__decorate([
    computed
], MessageModel.prototype, "isFromSameRetailerAsCurrentUser", null);
__decorate([
    computed
], MessageModel.prototype, "isFromSameBrandAsCurrentUser", null);
__decorate([
    computed
], MessageModel.prototype, "createdAt", null);
__decorate([
    computed
], MessageModel.prototype, "deletableUntil", null);
__decorate([
    computed
], MessageModel.prototype, "isRead", null);
__decorate([
    computed
], MessageModel.prototype, "shouldPopUp", null);
__decorate([
    computed
], MessageModel.prototype, "isLatestReadFromCurrentUser", null);
__decorate([
    computed
], MessageModel.prototype, "isLatestDelivered", null);
__decorate([
    computed
], MessageModel.prototype, "images", null);
__decorate([
    observable
], MessageModel.prototype, "_isDeleting", void 0);
__decorate([
    computed
], MessageModel.prototype, "isPending", null);
__decorate([
    action
], MessageModel.prototype, "setIsDeleting", void 0);
__decorate([
    computed
], MessageModel.prototype, "latestMessageAuthorFirstName", null);
__decorate([
    action
], MessageModel.prototype, "setError", void 0);
